const variables = require('@chama/statics/stylesheets/variables').default;

export default function handlePolylines() {
  // this == React Map component
  const { editMapMode } = this.props;
  if (editMapMode) {
    removePolylines.call(this);
  } else {
    drawPolylines.call(this);
  }
}

export function redrawPolylines() {
  // this == React Map component
  const { editMapMode } = this.props;
  removePolylines.call(this);
  if (!editMapMode) {
    drawPolylines.call(this);
  }
}

function removePolylines() {
  // this == React Map component
  const { polylines } = this;
  polylines.forEach(p => p.setMap(null));
  polylines.length = 0;
}

function drawPolylines() {
  // this == React Map component
  const { google, map, polylines } = this;
  const checkIfPolygon = ({ geometry }) => geometry instanceof google.maps.Data.Polygon;

  map.data.forEach(feature => {
    const geometry = feature.getGeometry();
    const isPolygon = checkIfPolygon({ geometry });

    if (!isPolygon) return false;

    const polylineCoords = geometryToCoords({ geometry });

    const polyline = createPolyline({ google, path: polylineCoords });

    // Storing polylines for fast removal and redrawing
    polylines.push(polyline);

    polyline.setMap(map);

    return polyline;
  });
}

function createLineSymbol({ google }) {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    fillOpacity: 1,
    scale: 1,
  };
}

function createPolyline({ google, path }) {
  return new google.maps.Polyline({
    path,
    strokeColor: variables['--nepal'],
    strokeOpacity: '0',
    icons: [
      {
        icon: createLineSymbol({ google }),
        offset: '0',
        repeat: '4px',
      },
    ],
  });
}

function geometryToCoords({ geometry }) {
  let firstPoint = null;
  const result = [];

  geometry.forEachLatLng(latlng => {
    const latLngObj = latlng.toJSON();
    if (!firstPoint) firstPoint = latLngObj;
    result.push(latLngObj);
  });

  result.push(firstPoint);
  return result;
}



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/Map/methods/handlePolylines.js